// eslint-disable-next-line no-restricted-properties
export var generateId = function generateId() {
  return Math.round(Math.random() * Math.pow(10, 16));
};